import get from 'lodash.get';

const getFolders = (rootState) => get(rootState, 'ws.site.meta.folders', []);

export default getFolders;
